'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConversionTimingMetrics } from './ConversionTimingMetrics';
import { useCheckoutToBillingAddressTimeData } from '@/lib/api/analytics';
import { useStatsFilters } from '../context/StatsFiltersContext';

interface CheckoutToBillingAddressTimeProps {
    className?: string;
}

export function CheckoutToBillingAddressTime({ className = '' }: CheckoutToBillingAddressTimeProps) {
    const { t } = useTranslation('analytics');
    const { selectedDates, selectedStores, selectedCurrency } = useStatsFilters();

    const { data, isLoading, error } = useCheckoutToBillingAddressTimeData(
        {
            startDate: selectedDates.from!,
            endDate: selectedDates.to!,
            storeIds: selectedStores,
            currency: selectedCurrency,
        },
        {
            enabled: !!(selectedDates.from && selectedDates.to),
        }
    );

    return (
        <ConversionTimingMetrics
            title={t('conversion.timing.checkoutToBilling.title')}
            description={t('conversion.timing.checkoutToBilling.description')}
            data={data}
            isLoading={isLoading}
            error={error}
        />
    );
}
